export default {
  item: {
    age: {
      title: "age",
      year: "year | years"
    },
    duration: {
      title: "duration",
      day: 'day | days',
      night: "night | nights",
      one: "one"
    },
    accommodation: {
      checkin: "check-in",
      checkout: "check-out",
      travelDate: "Your travel date"
    },
    offer: {
      title: "offer | offers",
      period: "offer period"
    },
    person: {
      adult: "adult | adults",
      child: "child | children",
      title: "person | people"
    }
  },
  mod: {
    accommodation: {
      title: "Accommodation",
      firstQuestion: "How would you like to stay?",
      message: {
        headline: "Would you like to write a message?",
        placeholder: "Your message",
        summaryTitle: "Message"
      },
      service: {
        question: "Which additional services would you like?"
      }
    },
    contact: {
      title: "Contact details",
      salutation: "Salutation",
      salutationOptions: [
        "Ms.",
        "Mr.",
        "Dr."
      ],
      firstName: "First name",
      lastName: "Last name",
      street: "Street and house number",
      zip: "Postal code",
      city: "City",
      country: "Country",
      countryOptions: [
        "Germany",
        "Austria",
        "Switzerland",
        "Belgium",
        "Denmark",
        "France",
        "United Kingdom",
        "Luxembourg",
        "Italy",
        "Canada",
        "Netherlands",
        "Poland",
        "Sweden",
        "Spain",
        "Czech Republic",
        "USA"
      ],
      email: "Email address",
      phone: "Phone number",
      availability: "Availability",
      availabilityOptions: [
        "Available in the evening",
        "Available in the morning",
        "Always available"
      ],
      errors: {
        salutation: "Incomplete/invalid input: salutation",
        firstName: "Please enter your first name.",
        lastName: "Please enter your last name.",
        email: "Please enter a valid email address.",
        phone: "Please enter your phone number.",
        street: "Please enter your street.",
        zip: "Please enter your postal code.",
        city: "Please enter your city.",
        country: "Please enter your country.",
        availability: "Please provide your availability."
      }
    },
    diverse: {
      title: "Your request",
      errors: {
        select: "Please make a selection.",
        required: "Please confirm."
      }
    },
    peopleConfigurator: {
      numberOfAdults: {
        decrease: "Decrease number of adults by one",
        increase: "Increase number of adults by one"
      },
      numberOfChildren: {
        decrease: "Decrease number of children by one",
        increase: "Increase number of children by one"
      },
      errors: {
        atLeastOne: "Please select at least one person.",
        ageMissing: "Please specify children's age."
      }
    },
    sidebar: {
      title: 'Recipient data',
      contact: "Contact",
      address: "Address",
      email: "Email address",
      phone: "Phone number"
    },
    summary: {
      title: "Summary & Send",
      headline: "Summary",
      dataProcessing: {
        title: "Data processing",
        text: "I consent to the collection, processing, and use of my personal data solely for the purpose of contact and offer creation in accordance with the privacy policy."
      },
      privacyPolicy: {
        defaultUrl: "/privacy-policy/",
        linkReplaceSearchText: "privacy policy",
        openLabel: "Open privacy policy"
      },
      emailCheck: {
        title: "Please check your email address"
      },
      errors: {
        dataProcessing: "We need your consent to process your data.",
        send: {
          base: "Oops! Something went wrong.",
          supportNotified: "Technical support has been notified. Please try again later.",
          contactSupport: "Please contact support and try again later."
        }
      },
      thankYou: {
        title: "Request sent",
        text: "Thank you for your request! We will get back to you shortly."
      }
    },
    traveldateoffer: {
      title: "Selection & Travel Date",
      firstQuestion: "What is your request?",
      offer: {
        title: "Which offer do you want?",
        readMore: "more details",
      },
      message: {
        title: "Your message",
        summaryTitle: "Message"
      },
      requestType: {
        offer: "Select offer",
        message: "Send message",
        accommodation: "Accommodation"
      },
      errors: {
        requestType: "Please select one of the options!",
        nights: "Please select exactly {days} days ({nights} overnight stays).",
        minNights: "Please select at least {days} days ({nights} minimum overnight stays).",
        maxNights: "Please select no more than {days} days (maximum {nights} overnight stays).",
        period: "Please select a date in the offer period."
      }
    }
  },
  form: {
    action: {
      view: "view",
      edit: "edit",
      add: "add {item}",
      remove: "remove",
      back: "back",
      next: "Next",
      submit: "Send request"
    },
    hint: {
      selected: 'Selected',
      selectPrompt: "Please select {item}",
      submitting: "Your request is being sent",
      travelDate: "Your travel date",
      nextDisabled: "Inputs are still inconsistent. Please check your entries!",
      optional: "(optional)",
      requestToSkip: "do not fill out",
      progress: 'progress'
    }
  },
  date: {
    formatDate: "DD.MM.YYYY",
    formatDateTime: "DD.MM.YYYY - HH:mm [o'clock]"
  }
}
